import { isNil, isString } from "lodash-es";
import uuid from "../utils/uuid";

export default abstract class Id<T extends string> {
  private readonly id: string;
  readonly #type?: T; // Necessary for type safety, no need to initialize it

  constructor(id: string) {
    this.id = id;
  }

  equals(other: this | string | undefined | null) {
    if (isNil(other)) {
      return false;
    }

    if (other instanceof this.constructor) {
      return other.toString() === this.id;
    }

    return other === this.id;
  }

  toJSON() {
    return this.id;
  }

  toString() {
    return this.id;
  }

  protected static validate(value: string) {
    return !isNil(value);
  }

  static from<T>(this: new (value: string) => T, value: string): T {
    const ctor = this as unknown as typeof Id;

    if (!ctor.validate(value) || !isString(value)) {
      throw new Error(`Invalid value for ${ctor.name}: ${value}`);
    }

    return new this(value);
  }

  static random<T>(this: new (value: string) => T): T {
    return new this(uuid());
  }
}
